module.exports = __webpack_public_path__ + "13c5d440bcfdb23602037e21aec795e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/partials/cham-soc-khach-hang.jpg
// module id = ./assets/images/partials/cham-soc-khach-hang.jpg
// module chunks = 0